import { i18n } from '@/services/i18n';
import { TaskType, TaskStatus } from '@/interfaces/server-data';

const TASK_TYPE_I18N_MAP: Record<string, string> = {
  [TaskType.PROMO]: 'backendValues.taskTypes.PROMO',
  [TaskType.REGULAR]: 'backendValues.taskTypes.REGULAR',
  [TaskType.SALES]: 'backendValues.taskTypes.SALES',
  [TaskType.PACKAGE_REGULAR]: 'backendValues.taskTypes.PACKAGE_REGULAR',
  [TaskType.PACKAGE_PROMO]: 'backendValues.taskTypes.PACKAGE_PROMO',
  [TaskType.BRUT_FORCE]: 'backendValues.taskTypes.BRUT_FORCE',
  [TaskType.SEARCH_KVI]: 'backendValues.taskTypes.SEARCH_KVI',
  [TaskType.PACKAGE_SCHEDULE]: 'backendValues.taskTypes.PACKAGE_SCHEDULE',
  [TaskType.PACKAGE_GENERAL]: 'backendValues.taskTypes.PACKAGE_GENERAL',
  [TaskType.PACKAGE_GENERAL_PROMO]: 'backendValues.taskTypes.PACKAGE_GENERAL_PROMO',
  [TaskType.PACKAGE_PROMO_RECOMMENDS]: 'backendValues.taskTypes.PACKAGE_PROMO_RECOMMENDS',
  [TaskType.PACKAGE_PROMO_GENERAL_RECOMMENDS]: 'backendValues.taskTypes.PACKAGE_PROMO_GENERAL_RECOMMENDS',
  [TaskType.PACKAGE_KVI_CARTS]: 'backendValues.taskTypes.PACKAGE_KVI_CARTS',
  [TaskType.PACKAGE_GENERAL_KVI_CARTS]: 'backendValues.taskTypes.PACKAGE_GENERAL_KVI_CARTS',
  [TaskType.PACKAGE_KVI_RECOMMENDS]: 'backendValues.taskTypes.PACKAGE_KVI_RECOMMENDS',
  [TaskType.PACKAGE_GENERAL_KVI_RECOMMENDS]: 'backendValues.taskTypes.PACKAGE_GENERAL_KVI_RECOMMENDS',
  [TaskType.PACKAGE_SCENARIO]: 'backendValues.taskTypes.PACKAGE_SCENARIO',
  [TaskType.PACKAGE_GENERAL_SCENARIO]: 'backendValues.taskTypes.PACKAGE_GENERAL_SCENARIO',
  [TaskType.PACKAGE_EVENTS]: 'backendValues.taskTypes.PACKAGE_EVENTS',
  [TaskType.PACKAGE_EVENTS_GENERAL]: 'backendValues.taskTypes.PACKAGE_EVENTS_GENERAL',
  [TaskType.PACKAGE_FIXED_PRICE]: 'backendValues.taskTypes.PACKAGE_FIXED_PRICE',
  [TaskType.PACKAGE_GENERAL_FIXED_PRICE]: 'backendValues.taskTypes.PACKAGE_GENERAL_FIXED_PRICE',
  [TaskType.PACKAGE_SALES]: 'backendValues.taskTypes.PACKAGE_SALES',
  [TaskType.PACKAGE_GENERAL_SALES]: 'backendValues.taskTypes.PACKAGE_GENERAL_SALES',
  [TaskType.PACKAGE_AGGREGATE_SALES]: 'backendValues.taskTypes.PACKAGE_AGGREGATE_SALES',
  [TaskType.PACKAGE_GENERAL_AGGREGATE_SALES]: 'backendValues.taskTypes.PACKAGE_GENERAL_AGGREGATE_SALES',
  [TaskType.PROMOTION]: 'backendValues.taskTypes.PROMOTION',
  [TaskType.PACKAGE_PROMOTION]: 'backendValues.taskTypes.PACKAGE_PROMOTION',
  [TaskType.PACKAGE_GENERAL_PROMOTION]: 'backendValues.taskTypes.PACKAGE_GENERAL_PROMOTION',
  [TaskType.PACKAGE_GENERAL_AGGREGATE_PROMOTION]: 'backendValues.taskTypes.PACKAGE_GENERAL_AGGREGATE_PROMOTION',
  [TaskType.REGULAR_PRICE_EXP]: 'backendValues.taskTypes.REGULAR_PRICE_EXP',
  [TaskType.SCHEDULED_PRICE_EXP]: 'backendValues.taskTypes.SCHEDULED_PRICE_EXP',
};

const TASK_STATUS_I18N_MAP: Record<string, string> = {
  [TaskStatus.INQUEUE]: 'backendValues.taskStatuses.InQueue',
  [TaskStatus.CALCULATING]: 'backendValues.taskStatuses.Calculating',
  [TaskStatus.CALCULATING_COMPLETE]: 'backendValues.taskStatuses.CalculatingComplete',
  [TaskStatus.WRITETOFILE]: 'backendValues.taskStatuses.WriteToFile',
  [TaskStatus.WRITETOFILECOMPLETE]: 'backendValues.taskStatuses.WriteToFileComplete',
  [TaskStatus.ERROR]: 'backendValues.taskStatuses.Error',
  [TaskStatus.ERROREXPORT]: 'backendValues.taskStatuses.ErrorExport',
  [TaskStatus.EMPTYDATA]: 'backendValues.taskStatuses.EmptyData',
  [TaskStatus.EXECUTIONEXCEPTION]: 'backendValues.taskStatuses.ExecutionException',
  [TaskStatus.PROMONOTRECOMMENDED]: 'backendValues.taskStatuses.PromoNotRecommended',
  [TaskStatus.ARITHMETICEXCEPTION]: 'backendValues.taskStatuses.ArithmeticException',
  [TaskStatus.RESTARTERROR]: 'backendValues.taskStatuses.RestartError',
  [TaskStatus.CANCELREPORT]: 'backendValues.taskStatuses.CancelReport',
  'TimeoutError': 'backendValues.taskStatuses.TimeoutError',
  [TaskStatus.ONAPPROVAL]: 'backendValues.taskStatuses.OnApproval',
  [TaskStatus.REJECTED]: 'backendValues.taskStatuses.Rejected',
  [TaskStatus.APPROVED]: 'backendValues.taskStatuses.Approved',
  [TaskStatus.PARTIALLY_APPROVED]: 'backendValues.taskStatuses.PartiallyApproved',
  [TaskStatus.PARTIALLY_REJECTED]: 'backendValues.taskStatuses.PartiallyRejected',
  [TaskStatus.SENT_TO_FINAL_APPROVAL]: 'backendValues.taskStatuses.SentToFinalApproval',
};

const FILE_STATUS_KNOWN_VALUES = [
  'Идет загрузка',
  'Загрузка завершена',
  'Произошла ошибка',
  'Ошибка при загрузке файла',
  'Ошибка валидации файла',
  'Не удалось определить значение. ',
  'Идет запись в базу',
  'Идет запиcь в базу',
  'Запись в базу завершена',
  'Запись в базу завершена. Некоторые данные были перезаписаны',
  'Загрузка в базу завершена',
  'Загрузка в базу завершена. Некоторые данные были перезаписаны',
  'Идёт удаление файла и его данных',
  'При удалении файла произошла ошибка',
  'При удалении данных файла произошла ошибка',
  'Удаление файла прошло успешно',
  'Недостаточно свободного места на диске',
  'В очереди на удаление',
  'В очереди',
];

const FILE_STATUS_I18N_MAP: Record<string, string> = {
  'Идет загрузка': 'backendValues.fileStatuses.downloading',
  'Загрузка завершена': 'backendValues.fileStatuses.downloadingComplete',
  'Произошла ошибка': 'backendValues.fileStatuses.error',
  'Ошибка при загрузке файла': 'backendValues.fileStatuses.errorFileImport',
  'Ошибка валидации файла': 'backendValues.fileStatuses.errorImportValidation',
  'Не удалось определить значение. ': 'backendValues.fileStatuses.errorParseException',
  'Идет запись в базу': 'backendValues.fileStatuses.writeToDatabase',
  'Идет запиcь в базу': 'backendValues.fileStatuses.writeToDatabase', // тут символ один не русский, так на беке
  'Запись в базу завершена': 'backendValues.fileStatuses.writeToDatabaseComplete',
  'Запись в базу завершена. Некоторые данные были перезаписаны': 'backendValues.fileStatuses.writeToDatabaseCompleteWithOverwrite',
  'Загрузка в базу завершена': 'backendValues.fileStatuses.uploadToDatabaseComplete',
  'Загрузка в базу завершена. Некоторые данные были перезаписаны': 'backendValues.fileStatuses.uploadToDatabaseCompleteWithOverwrite',
  'Идёт удаление файла и его данных': 'backendValues.fileStatuses.deleteFile',
  'При удалении файла произошла ошибка': 'backendValues.fileStatuses.deleteFileError',
  'При удалении данных файла произошла ошибка': 'backendValues.fileStatuses.deleteFileDataError',
  'Удаление файла прошло успешно': 'backendValues.fileStatuses.deleteFileComplete',
  'Недостаточно свободного места на диске': 'backendValues.fileStatuses.insufficientDiskSpace',
  'В очереди на удаление': 'backendValues.fileStatuses.inQueueToDelete',
  'В очереди': 'backendValues.fileStatuses.inQueue',
};

const WRITING_TO_DB_PATTERNS = [
  'Идет запись в базу',
  'Идет запиcь в базу', // тут символ один не русский, так на беке
];

export function localizeTaskType(typeMachine: string): string {
  const key = TASK_TYPE_I18N_MAP[typeMachine];
  if (key) {
    return i18n.t(key) as string;
  }
  return typeMachine;
}

export function localizeTaskStatus(statusEnum: string): string {
  const key = TASK_STATUS_I18N_MAP[statusEnum];
  if (key) {
    return i18n.t(key) as string;
  }
  return statusEnum;
}

export function localizeFileStatusMessage(message: string | null | undefined): string {
  if (!message) return '';

  const trimmed = message.trim();

  const exactKey = FILE_STATUS_I18N_MAP[trimmed];

  if (exactKey) {
    return i18n.t(exactKey) as string;
  }

  for (const [ruText, i18nKey] of Object.entries(FILE_STATUS_I18N_MAP)) {
    if (trimmed.startsWith(ruText)) {
      const suffix = trimmed.slice(ruText.length);

      return (i18n.t(i18nKey) as string) + suffix;
    }
  }

  return message;
}

export function isWritingToDatabase(statusMessage: string | null | undefined): boolean {
  if (!statusMessage) return false;

  return WRITING_TO_DB_PATTERNS.some(pattern => statusMessage === pattern);
}
